import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

import firebaseConfig from "./firebaseConfig";

const firebaseApp = initializeApp(firebaseConfig);

const analytics = getAnalytics(firebaseApp);

const db = getFirestore(firebaseApp);

const auth = getAuth(firebaseApp);

const storage = getStorage(firebaseApp);

export { analytics, db, auth, storage };
